// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { CommitmentOrChangeOrderPdf_DrawFragmentDoc } from '../../../pdfs/CommitmentOrChangeOrderPdf/CommitmentOrChangeOrderPdf.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PaymentScheduleTabQueryVariables = Types.Exact<{
  commitmentId: Types.Scalars['ID']['input'];
}>;


export type PaymentScheduleTabQuery = { __typename?: 'Query', commitment: { __typename?: 'Commitment', id: string, committedInCents: number, depositInBasisPoints?: number | null | undefined, draws: Array<{ __typename?: 'CommitmentDraw', id: string, amountInBasisPoints: number, description?: string | null | undefined, task: { __typename?: 'Task', id: string, name: string, status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string } } }>, project:
      | { __typename?: 'StandaloneProject', id: string }
      | { __typename?: 'Region', id: string }
      | { __typename?: 'Market', id: string }
      | { __typename?: 'Community', id: string }
      | { __typename?: 'Subdivision', id: string }
      | { __typename?: 'Lot', id: string }
      | { __typename?: 'Structure', id: string }
      | { __typename?: 'Unit', id: string }
     } };


export const PaymentScheduleTabDocument = gql`
    query PaymentScheduleTab($commitmentId: ID!) {
  commitment(id: $commitmentId) {
    id
    committedInCents
    depositInBasisPoints
    draws {
      ...CommitmentOrChangeOrderPdf_Draw
    }
    project {
      id
    }
  }
}
    ${CommitmentOrChangeOrderPdf_DrawFragmentDoc}`;

/**
 * __usePaymentScheduleTabQuery__
 *
 * To run a query within a React component, call `usePaymentScheduleTabQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentScheduleTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentScheduleTabQuery({
 *   variables: {
 *      commitmentId: // value for 'commitmentId'
 *   },
 * });
 */
export function usePaymentScheduleTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaymentScheduleTabQuery, PaymentScheduleTabQueryVariables> & ({ variables: PaymentScheduleTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaymentScheduleTabQuery, PaymentScheduleTabQueryVariables>(PaymentScheduleTabDocument, options);
      }
export function usePaymentScheduleTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaymentScheduleTabQuery, PaymentScheduleTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaymentScheduleTabQuery, PaymentScheduleTabQueryVariables>(PaymentScheduleTabDocument, options);
        }
// @ts-ignore
export function usePaymentScheduleTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PaymentScheduleTabQuery, PaymentScheduleTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaymentScheduleTabQuery, PaymentScheduleTabQueryVariables>;
export function usePaymentScheduleTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaymentScheduleTabQuery, PaymentScheduleTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PaymentScheduleTabQuery | undefined, PaymentScheduleTabQueryVariables>;
export function usePaymentScheduleTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PaymentScheduleTabQuery, PaymentScheduleTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PaymentScheduleTabQuery, PaymentScheduleTabQueryVariables>(PaymentScheduleTabDocument, options);
        }
export type PaymentScheduleTabQueryHookResult = ReturnType<typeof usePaymentScheduleTabQuery>;
export type PaymentScheduleTabLazyQueryHookResult = ReturnType<typeof usePaymentScheduleTabLazyQuery>;
export type PaymentScheduleTabSuspenseQueryHookResult = ReturnType<typeof usePaymentScheduleTabSuspenseQuery>;
export type PaymentScheduleTabQueryResult = Apollo.QueryResult<PaymentScheduleTabQuery, PaymentScheduleTabQueryVariables>;